import Login from "./calls/Login";
import Storage from './Storage';

//  In milliseconds
const maxWaitTime = 60000;
const timeBetweenChecks = 5000;

const SAML = class {
	login: InstanceType<typeof Login>;
	storage: InstanceType<typeof Storage>;
	clientId: string;
	intervalId?: any;
	currentTime: number;
	successCallback: (o: StringObject) => void;

	constructor(clientId: string, storage: InstanceType<typeof Storage>, successCallback: (o: StringObject) => void) {
		this.login = new Login()
		this.storage = storage
		this.clientId = clientId
		this.currentTime = 0;
		this.successCallback = successCallback;
	}

	async tryThroughNewWindow(email: string) {
		return new Promise((resolve, reject) => {
			this.login.samlLogin(email, this.clientId, false)
			.then((r: any) => {
				window.open(r.data.url);
				this.intervalId = setInterval(
					async () => {
						this.currentTime += timeBetweenChecks

						if(this.currentTime >= maxWaitTime) {
							this.stop();
							reject('Timeout');
						} else {
							await this.login.samlAuthed(email, r.data.cookie)
							.then(async (r: any) => {
								this.stop();
								await this.successCallback(r.data)
								resolve(1)
							})
							.catch(r => console.error(r))
						}
					},
					timeBetweenChecks
				)
			})
			.catch(() => reject('No SAML for that alias'))
		})
	}

	// Should be private
	stop() {
		clearInterval(this.intervalId)
		this.currentTime = 0;
		this.intervalId = null;
	}
}

export default SAML;
